export enum SectionStateStatus {
  Loading = 'Loading',
  LoadingTransparent = 'LoadingTransparent',
  HideLoading = 'HideLoading',
  Ready = 'Ready',
  Disconnected = 'Disconnected',
  Error = 'Error',
  Empty = 'Empty',
  SearchResultEmpty = 'SearchResultEmpty',
  ComingSoon = 'ComingSoon'
}
